var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.3 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M209.3 122.6V200h-44.9v-72.2c0-18.1-6.5-30.5-22.7-30.5-12.4 0-19.8 8.3-23 16.4-1.2 2.9-1.5 6.9-1.5 10.9V200H72.3s.6-122.3 0-134.9h44.9v19.1c-.1.1-.2.3-.3.4h.3v-.4c6-9.2 16.6-22.3 40.4-22.3 29.6 0 51.7 19.3 51.7 60.7M25.4 0C10 0 0 10.1 0 23.3c0 13 9.8 23.3 24.8 23.3h.3c15.6 0 25.4-10.4 25.4-23.3C50.2 10.1 40.7 0 25.4 0M2.7 200h44.9V65.1H2.7zm0 0"
  })));
};
export default SvgLinkedin;